<template>
    <v-card max-height="70vh" style="background-color:transparent;" class=" elevation-0">
        <v-card-title>
            <h3 class="text-left with-short-rule">Quility B2B Agency Agreement</h3>
        </v-card-title>
        <v-card-text>
            <div class="scroll elevation-0 pa-4" style="height: calc(60vh - 175px); text-align:left; border:#ccc 1px solid; ">
                <page slug="agency-agreement" :noTemplate="true" />
            </div>
        </v-card-text>
        <v-card-actions>
            <v-spacer />
            <div class="text-center mb-12" style="width:100%;max-width:800px">
                <v-btn color="primary" large href="https://wholesale-hq.quility.com/api/public/document/126/view/wholesale-agency-agreement" target="_blank">View Agency Agreement</v-btn>

                <p class="mt-8 mb-0">
                    Please type <strong>{{ userName }}</strong> in the space below to confirm that you have reviewed and agreed to the terms of the Quility B2B Agency Agreement.
                </p>
                <v-text-field class="my-4" v-model="fullName" :label="label" />

                <v-btn tile depressed large color="primary" :disabled="!fullNameTyped" @click="acceptAgencyAgreement">Accept</v-btn>
                <v-btn tile depressed @click="rejectAgencyAgreement">Reject</v-btn>
            </div>
            <v-spacer />
        </v-card-actions>
        <v-progress-linear indeterminate v-if="config_loading"></v-progress-linear>
    </v-card>
</template>

<script>
import Page from '@/CMS/views/index.vue'
import ReleaseMeta from '@/ReleaseMeta.json'
import PageStore from '@/store/Models/Page'

function stripHtml(html)
{
   const tmp = document.createElement('div');
   tmp.innerHTML = html;
   return tmp.textContent || tmp.innerText || '';
}

export default {
    props: [],
    data() {
        return {
            config_loading: false,
            fullName: '',
        }
    },
    computed: {
        userName() {
            return this.$auth.auth_user.name
        },
        fullNameTyped() {
            // Convert both strings to lowercase and remove all whitespace
            const fullNameLower = this.fullName.toLowerCase().replace(/\s+/g, '')
            const userNameLower = this.userName.toLowerCase().replace(/\s+/g, '')
            
            // Compare the transformed strings
            return fullNameLower === userNameLower
        },
        label() {
            return `Type "${this.userName}" for acceptance`
        },
    },
    methods: {
        acceptAgencyAgreement() {
            this.config_loading = true
            const page = PageStore.query().where('slug', 'agency-agreement').first();
            const body = page.blocks.filter(({ type }) => type === 'full-width-text')
                .map(({ text }) => text)
                .join(' ')
            const bodyText = stripHtml(body)
            const value = {
                AgentSignature: this.$auth.auth_user.name,
                AgreementBody: bodyText,
            }
            this.updateConfig("AcceptedAgencyAgreement " + ReleaseMeta.Version, value, "json").then((json) => {
                this.config_loading = false
            })
        },
        rejectAgencyAgreement() {
            this.config_loading = true
            this.updateConfig("AcceptedAgencyAgreement " + ReleaseMeta.Version, null, "json").then((json) => {
                this.config_loading = false
                this.$auth.logout({
                    returnTo: window.location.origin
                });
            })
        }
    },
    components: {
        Page,
    }
}
</script>
